<style lang="scss" scoped>

    .myAmpleon .main .container {
        width: auto;
    }

    .myAmpleon .content {
        @media screen and (max-width: 767px) {
            margin-top: 0;
        }
    }

    h3.page-title {
        color: #000 !important;
        font-size: 24px;
        line-height: 29px;
    }

    .sidebar, .banner {
        display: none;
    }

    .content {
        left: 0;
        width: 100% !important;
    }

    .row__subscriptions {
        min-height: 100vh;

        @media (max-width: 991px) {
            flex-direction: column-reverse;
            min-height: auto;
        }

        .parametric-intro {
            margin: 0;
        }

        .page-title {

            @media (max-width: 767px) {
                padding: 15px 0 !important;
            }
        }

        .image-section {

            @media (max-width: 991px) {
                height: 270px;
            }

            @media (max-width: 767px) {
                height: 402px;
            }
        }
    }

    .row--flex {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
    }

    .image-section {
        display: flex;
        flex-direction: column;
        font-family: "Open Sans", sans-serif;
        position: relative;
        height: 100vh;
        background-image: url("../assets/images/register-img.jpg");
        background-position: center;
        -webkit-background-size: cover;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .overlay {
        opacity: 0.8;
        color: #fff;
        background: #003B71;
        width: 100%;
        height: 100%;
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
    }

    .svg-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 300px;
        height: 170px;

        path {
            fill: #ffffff;
        }
    }

    .col-spacing-75 {
        padding: 0 75px;

        @media (max-width: 991px) {
            padding: 0 25px;
        }

        @media (max-width: 767px) {
            padding: 0 15px;
        }
    }

    .form-check-label {
        margin: 0 0 0 20px;
        font-size: 12px;
        font-weight: 300;
        line-height: 13px;
        transform: translateY(0px);
    }

    .form-textarea {
        width: 100%;
    }

    .invalid-feedback {
        color: red;
        margin-left: 12px;
        margin-bottom: 0;
    }

    .subscriptions-intro {
        margin: 0;
        padding-top: 43px !important;
    }

    .label-forgot-pass {
        float: right;
        font-weight: bold;
    }

    .login-question {
        margin-bottom: 48px;
    }

    .account-question-paragraph {
        font-size: 15px;
        font-weight: bold;
        line-height: 13px;
    }

    .login-button {
        padding-left: 35px;
        padding-right: 35px;
    }

    .registration-problems {
        margin-top: 40px;
        font-weight: bold;
    }

    .form-control {
        padding: 5px 18px;
        border-color: #ddd;
        box-shadow: none;
        font-size: 14px;
        line-height: 20px;

        &::-webkit-input-placeholder { /* Edge */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &::placeholder {
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }
    }

    .subscription-wrapper label {
        font-size: 15px;
    }

    .subscription-heading {
        margin-bottom: 20px;
    }

    .areas-section {
        padding-left: 20px;
    }

    .frequency-section {
        padding-left: 20px;

        .form-check {
            margin-bottom: 10px;
        }
    }

    .subscription-buttons {
        display: flex;
        padding-left: 20px;
        margin-top: 15px;

        @media (max-width: 767px) {
            margin-left: 0;
        }
    }

    .save-button-wrap {
        margin-right: 5px;
    }

    .subscription-intro__description {
        padding-bottom: 20px;
    }
</style>

<template>
    <div class="subscription-wrapper">
        <top-bar active-item="subscription" />
        <div class="row row--flex row__subscriptions">
            <div class="col-md-6 col-spacing-75">
                <div class="subscriptions-intro">
                    <h3 class="page-title">My Subscriptions</h3>
                    <Alert v-if="submitted  && alertSuccess" message="Success: Changes are successfully saved" color="green"></Alert>
                    <Alert v-if="submitted && alertError" message="Failure: Something went wrong while saving the subscriptions changes. Please try again later." color="red"></Alert>
                    <Alert v-if="categoriesFetchError" message="Failure: Something went wrong while fetching the subscription topics. Please try again later." color="red"></Alert>
                    <Alert v-if="userFetchError" message="Failure: Something went wrong while fetching the user data. Please try again later." color="red"></Alert>

                    <p class="subscription-intro__description">
                        We want you to only get what you really need in a frequency you prefer.
                        Therefore, we suggest you specify your areas of interest so that any updates we provide are tailored to your needs reaching you in intervals you prefer.</p>

                </div>

                <form @submit.prevent="handleSubmit">

                    <h4 class="subscription-heading">Areas of Interest</h4>

                    <div v-for="(item, index) in topics" class="areas-section">
                        <div class="row form-row">
                            <div class="form-group form-group-check-first col-md-12 m-b-5">
                                <div class="form-check">
                                        <span class="custom-checkbox custom-checkbox-wrapper">
                                            <input class="custom-checkbox__input" type="checkbox"
                                                   v-model="item.value"
                                                   :id="`subscription-checkmark-${index}`"
                                            />
                                            <span class="custom-checkbox__checkmark">
                                            </span>
                                        </span>
                                    <label class="form-check-label custom-control-label" :for="`subscription-checkmark-${index}`">{{item.title}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h4 class="subscription-heading">Frequency</h4>

                    <div class="areas-section">
                        <div class="row form-row">
                            <div class="form-group form-group-check-first col-md-12 m-b-5">
                                <div class="form-check">
                                        <span class="custom-checkbox custom-checkbox-wrapper">
                                            <input class="custom-checkbox__input" type="checkbox"
                                                   v-model="weekly"
                                                   id="subscription-weekly"
                                            />
                                            <span class="custom-checkbox__checkmark">
                                            </span>
                                        </span>
                                    <label class="form-check-label custom-control-label" for="subscription-weekly">Weekly</label>
                                </div>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="form-group form-group-check-first col-md-12 m-b-5">
                                <div class="form-check">
                                        <span class="custom-checkbox custom-checkbox-wrapper">
                                            <input class="custom-checkbox__input" type="checkbox"
                                                   v-model="monthly"
                                                   id="subscription-monthly"
                                            />
                                            <span class="custom-checkbox__checkmark">
                                            </span>
                                        </span>
                                    <label class="form-check-label custom-control-label" for="subscription-monthly">Monthly</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="subscription-buttons row form-row">
                        <div class="form-group save-button-wrap">
                            <button type="submit"
                                    class="btn btn-primary">Save
                            </button>
                        </div>
                    </div>

                </form>
            </div>

            <div class="col-md-6 image-section">
                <div class="overlay">
                    <div class="svg-wrapper">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 302 172" style="enable-background:new 0 0 302 172;" xml:space="preserve">
                            <path fill="#ffffff" class="st0" d="M151,0.9c21.6,0,31.3,11,34.8,38.1L198,139.2c1,8.1,1.9,9.3,5.8,9.3c3.3,0,4.4-1.2,5.4-9.3l12.2-100.1
                                c3.3-27.2,13.7-38.1,34.8-38.1c23,0,33.4,11,35.4,38.1l9.1,120c0.8,9.5-1.7,12-11.2,12h-3.9c-9.5,0-12-2.3-12.6-12l-8.3-119.8
                                c-0.8-11.2-3.1-14.1-9.1-14.1c-5.2,0-7.9,2.9-9.1,14.1l-14.1,104.3c-2.9,20.5-9.1,27.6-28.8,27.6c-17.4,0-25.9-6.8-28.8-27.6
                                L160.5,39.3c-1.2-11.2-3.9-14.1-9.3-14.1h-0.4c-5.4,0-8.1,2.9-9.3,14.1l-14.3,104.3c-2.9,20.7-11.4,27.6-28.8,27.6
                                c-19.7,0-25.9-7-28.8-27.6L55.5,39.3c-1.2-11.2-3.9-14.1-9.1-14.1c-6,0-8.3,2.9-9.1,14.1l-8.3,119.8c-0.8,9.5-3.1,12-12.6,12h-3.9
                                c-9.5,0-12-2.3-11.2-12l9.1-120C12.3,11.9,22.7,0.9,45.7,0.9c20.9,0,31.3,11,34.8,38.1l12.2,100.1c1,8.1,2.1,9.3,5.4,9.3
                                c3.9,0,4.8-1.2,5.8-9.3l12.2-100.1C119.7,11.7,129.4,0.9,151,0.9z"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopBar from "./TopBar";
    import {ProductsService, UserService} from "../common/api.service";
    import {mapAsyncGetters, STATUS} from "../store/utils/async";
    import {FINALIZE_ACTION, UPDATE_USER_SUBSCRIPTIONS} from "../store/actions.type";
    import Alert from "./Alert";

    export default {
        name: "MySubscription",
        components: {
            TopBar,
            Alert
        },
        data() {
            return {
                categoriesFetchError: false,
                userFetchError: false,
                submitted: false,
                alertSuccess: false,
                alertError: false,
                topics: [],
                weekly: false,
                monthly: false,
            };
        },
        async mounted() {
            await ProductsService.getProductCategories()
                .then(({data}) => {
                    if(data.success) {
                        this.topics = data.items.map(item => {
                            return {
                                id: item.id,
                                title: item.title,
                                value: false
                            }
                        });
                        return UserService.getUserAccount(this.getUser.email);
                    } else {
                        this.categoriesFetchError = true;
                    }})
                .then(({data}) => {
                    if(data.success) {
                        if (data.subscriptionFrequencies) {
                            this.weekly = data.subscriptionFrequencies.includes('WEEKLY');
                            this.monthly = data.subscriptionFrequencies.includes('MONTHLY');
                        }
                        if (data.subscriptionTopics) {
                            this.topics.forEach(topic => topic.value = data.subscriptionTopics.includes(topic.id));
                        }
                    } else {
                        this.userFetchError = true;
                    }})
        },
        computed: {
            ...mapAsyncGetters(UPDATE_USER_SUBSCRIPTIONS),
            getUser : function () {
                return this.$store.getters.user;
            },
            frequencies() {
                let list = [];
                if (this.weekly) {
                    list.push('WEEKLY');
                }
                if (this.monthly) {
                    list.push('MONTHLY')
                }
                return list;
            }
        },
        watch: {
            status: function (newValue) {
                if (this.isFinished) {
                    if (newValue === STATUS.SUCCESS) {
                        this.alertSuccess = true;
                    } else if (newValue === STATUS.FAILURE) {
                        this.alertError = true;
                    }
                }
            }
        },
        methods: {
            handleSubmit() {
                this.submitted = true;
                let payload = {
                    email: this.getUser.email,
                    subscriptionFrequencies: this.frequencies,
                    subscriptionTopics: this.topics.filter(topic => topic.value).map(topic => topic.id)
                };
                this.$store.dispatch(UPDATE_USER_SUBSCRIPTIONS, payload)
                    .then(() => this.$store.dispatch(FINALIZE_ACTION, UPDATE_USER_SUBSCRIPTIONS));
            }
        }
    };
</script>

